import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Camera, Incident, StatusType } from 'src/api/models';
import { FireForesightService } from 'src/api/services';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { FireService } from 'src/service/fire.service';

@Component({
  selector: 'fireforesightlayout',
  templateUrl: 'fireForesightLayout.template.html',
})
export class FireForesightLayoutComponent implements OnInit {

  public isNavigationOpen = false;
  public cameras : Camera[];
  public statusTypes : StatusType[];
  public incidents : Incident[];
  public siteId: any;
  public siteIdFilter: any;
  public incidentId: any;
  public view: string;
  public isWatchView: boolean = false;

  constructor(
    private router: Router,
    public app: ApplicationConfigService,
    private fire: FireService,
    private svc: FireForesightService,
    public azureAuthService: AzureAuthService,
    private toasterService: ToastrService
  ) {
    router.events.subscribe(val => {
      const route: any = val;
      if (route.url){
        //console.log(route.url);
        const parts = route.url.split('/');
        if (parts.length > 2 && parts[2] != null){
          this.view = parts[2].toLowerCase();
          this.isWatchView = this.view === 'watch';
          if (this.view.startsWith("camera")) {
            if (parts.length > 3){
              const uri = parts[3];
              this.siteId = Number(uri);
            }
          } else if (this.view.startsWith("incident")) {
            if (parts.length > 3){
              const uri = parts[3];
              this.incidentId = Number(uri);
            }
          }
        }
      }
    });
  }

  ngOnInit() {
    this.azureAuthService.onInit();

    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-small');

    if (this.view.startsWith("incident")) {
      this.svc.FireForesightGetStatusTypes().subscribe(st => {
        this.statusTypes = st.filter(s => s.visible == true);
      });
      this.fire.get(false);
    } else {
      this.fire.get(false);
    }
  }

  onResize() {
  }

  onNavigationToggle(bool: boolean): void {
    const body = document.getElementsByTagName('body')[0];
    if (bool) {
      body.classList.add('mini-navbar');
    } else {
      body.classList.remove('mini-navbar');
    }
  }

  changeCameraFilter(camera){

  }
}
